import React, { useContext } from "react"
import PropTypes from "prop-types"
import { analysisContext } from "context/analysis-context"

function ExtractedField({ fieldData = {} }) {
  const { id, name, value } = fieldData
  const { selectedBox, changeSelectedBox } = useContext(analysisContext)

  const isHover = selectedBox.name === name

  return (
    <div className="mb-3" key={id}>
      <h6 className="mb-1">{name}</h6>
      <div
        className={`p-2 rounded border-start border-primary bg-primary-subtle ${
          isHover ? "border-5" : "border-2"
        }`}
        onMouseEnter={() => changeSelectedBox(fieldData)}
        onMouseLeave={() => changeSelectedBox({})}
      >
        {value}
      </div>
    </div>
  )
}

ExtractedField.propTypes = {
  fieldData: PropTypes.object,
}

export default ExtractedField
